import React, { useContext, useEffect, useMemo } from 'react'
import * as classes from './Partnership.module.scss'
import { deleteHtmlTag } from '../../../utils/deleteHtmlTag'
import splitRow from '../../../utils/splitRow'
import { startAnimationScroll } from '../../../utils/animations'
import { FormContext } from '../../../context'
import splitTitleV2 from '../../../utils/splitTitleV2'
import Partners from './Partners/Partners'
import Presentations from './Presentations/Presentations'

function Partnership({ data, lang }) {
    const { animationStart } = useContext(FormContext)

    const titleOne = useMemo(() => deleteHtmlTag(data.titleOne.value, 'p'), [data.titleOne.value])

    const titleTwo = useMemo(() => deleteHtmlTag(data.titleTwo.value, 'p'), [data.titleTwo.value])
    const textTwo = useMemo(() => deleteHtmlTag(data.textTwo.value, 'p'), [data.textTwo.value])
    const emailTwo = useMemo(() => deleteHtmlTag(data.emailTwo.value, 'p'), [data.emailTwo.value])
    const previewImage = useMemo(() => data.preview.previewImage.url, [data.preview.previewImage.url])
    const title = {
        top: titleOne,
        bottom: titleTwo
    }

    const classAnimationTitle = 'anime-title-partnership'
    const classAnimationText = 'anime-text-partnership'

    useEffect(() => {
        if (animationStart) {
            splitRow(classAnimationText)
            splitTitleV2(classAnimationTitle)
        }

        const observer = startAnimationScroll([
            { type: 'title', className: classAnimationTitle },
            { type: 'text', className: classAnimationText }
        ])

        return () => {
            if (observer) {
                observer.disconnect()
            }
        }
    }, [animationStart])

    return (
        <>
            {/* {sectionTitle || title.top || textOne || emailOne ? (
                <section className={classes.Top}>
                    <Container>
                        {sectionTitle ? <SectionTitle title={sectionTitle} lang={lang} /> : null}

                        {title.top ? (
                            <div className={classes.RowTop}>
                                <h2 className={`${classes.Title} ${classAnimationTitle}`} dangerouslySetInnerHTML={{ __html: title.top }} />
                            </div>
                        ) : null}

                        {textOne || emailOne ? (
                            <div className={classes.RowBottom}>
                                <div className={`${classes.Content} ${classAnimationText}`} data-lang={lang}>
                                    {textOne ? <p dangerouslySetInnerHTML={{ __html: textOne }} /> : null}

                                    {emailOne ? (
                                        <a
                                            className={classes.Email}
                                            href={`mailto:${emailOne}`}
                                            dangerouslySetInnerHTML={{ __html: emailOne }}
                                        />
                                    ) : null}
                                </div>
                            </div>
                        ) : null}
                    </Container>
                </section>
            ) : null} */}

            <Partners data={data} lang={lang} />

            {title.bottom || textTwo || emailTwo ? (
                <section className={classes.Bottom}>
                    <div className={classes.Card}>
                        <div className={classes.CardContent}>
                            {title.bottom ? (
                                <h2
                                    className={`${classes.CardTitle} ${classAnimationTitle}`}
                                    dangerouslySetInnerHTML={{ __html: title.bottom }}
                                />
                            ) : null}

                            {textTwo || emailTwo ? (
                                <div className={`${classes.CardText} ${classAnimationText}`} data-lang={lang}>
                                    {textTwo ? <p dangerouslySetInnerHTML={{ __html: textTwo }} /> : null}

                                    {emailTwo ? (
                                        <a
                                            className={classes.CardEmail}
                                            href={`mailto:${emailTwo}`}
                                            aria-label={emailTwo}
                                            dangerouslySetInnerHTML={{ __html: emailTwo }}
                                        />
                                    ) : null}
                                </div>
                            ) : null}
                        </div>

                        <img className={classes.CardImage} src={previewImage} alt="Partners preview" />
                    </div>
                </section>
            ) : null}

            <Presentations files={data.presentations?.nodes} lang={lang} />
        </>
    )
}

export default Partnership
